import { AssistantsTable } from "@/components/Assistant/AssistantsTable";

const CoWorkersWorkshop = () => {
  return (
    <div className="w-full flex flex-col flex-1 pb-5">
      <AssistantsTable />
    </div>
  );
};

export default CoWorkersWorkshop;
